import React, { Component } from 'react';
import { observer } from 'mobx-react';
import _ from 'lodash';

import { CheckGroup, PeriodTime } from '../forms/FormItems';
import { CalendarIcon } from '../images/icons';

/** Общий блок настройки рабочих дней и времени */
export class WorkDaysBlock extends Component {
	render() {
		return(
			<div className={'section workdays ' + (this.props.ClassName || '')}>
				<h4 className="sectionTitle"><CalendarIcon />{this.props.Title}</h4>
				{this.props.children}
				<div className="header">
					<h5>{this.props.SubTitle || "Время работы"}</h5>
					<button type="button" className="dotted" disabled={this.props.Disabled}
						onClick={() => this.props.WorkDays.setDays("all")}>Ежедневно</button>
					<button type="button" className="dotted" disabled={this.props.Disabled}
						onClick={() => this.props.WorkDays.setDays("work")}>ПН-ПТ</button>
				</div>
				{_.map(this.props.WorkDays.List, (item, index) =>
					<WorkDayItem
						key={'d' + index}
						Index={index}
						Item={item}
						WorkDays={this.props.WorkDays}
						Disabled={this.props.Disabled}
					/>
				)}
			</div>
		)
	}
}
WorkDaysBlock = observer(WorkDaysBlock);

/** Строка настройки рабочего дня */
class WorkDayItem extends Component {
	render() {
		return(
			<div className="day">
				<CheckGroup
					Id="Day"
					Type="checkbox"
					List={[{ Id : this.props.Index, Title : this.props.Item.Name }]}
					Value={this.props.Item.Day !== -1 && this.props.Item.Day !== "" ? [this.props.Index] : []}
					Disabled={this.props.Disabled}
					onChange={(value, id) => this.props.Item.collect(id, value, this.props.Index)}
				/>
				<PeriodTime
					Id="Time"
					Index={this.props.Index}
					Value={{ StartTime : this.props.Item.StartTime, EndTime : this.props.Item.EndTime }}
					Required={this.props.Item.Day !== -1 && this.props.Item.Day !== ""}
					Disabled={this.props.Disabled}
					onChange={(value, id) => this.props.Item.collect(id, value, this.props.Index)}
				/>
				{this.props.Index === 0 &&
					<button type="button" className="dotted applyAll" disabled={this.props.Disabled}
						onClick={this.props.WorkDays.setHours}>Применить ко всем</button>
				}
			</div>
		)
	}
}
WorkDayItem = observer(WorkDayItem);
